import { createActionGroup } from '@ngrx/store';
import { zefActionFailPayload, zefActionPayload, zefActionSuccessPayload } from '@zerops/zef/core';
import { IntegrationTokenWithSecret, IntegrationTokenListResponse } from '@zerops/models/integration-token';
import { FEATURE_NAME } from './integration-token-base.constant';

export const integrationTokenActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    'Load Tokens': zefActionPayload<Record<string, never>>(),
    'Load Tokens Success': zefActionSuccessPayload<IntegrationTokenListResponse>(),
    'Load Tokens Fail': zefActionFailPayload,

    'Regenerate Token': zefActionPayload<{ tokenId: string }>(),
    'Regenerate Token Success': zefActionSuccessPayload<IntegrationTokenWithSecret>(),
    'Regenerate Token Fail': zefActionFailPayload
  }
});
